import { useTranslation } from "react-i18next";
import { Box, Collapse, Stack } from "@mui/material";
import { EGCheckbox } from "../../MainComponents/Checkbox/EGCheckbox";
import "./StatusFilter.scss";

const MAIN_STATUSES = ["new", "pending", "process", "finish", "closed"];
const CLOSED_TYPES = ["founded", "unfounded", "undefined", "closing_process"];

export const StatusFilter = ({
  statuses,
  setStatuses,
  closedTypes,
  setClosedTypes,
}) => {
  const [t] = useTranslation("report");
  const [tExports] = useTranslation("exports");

  const isClosedChecked = statuses.includes("closed");

  const toggleStatus = (status) => {
    if (status === "closed") {
      if (isClosedChecked) {
        setStatuses(statuses.filter((s) => s !== "closed"));
        setClosedTypes([]);
      } else {
        setStatuses([...statuses, "closed"]);
        setClosedTypes([...CLOSED_TYPES]);
      }
      return;
    }
    if (statuses.includes(status)) {
      setStatuses(statuses.filter((s) => s !== status));
    } else {
      setStatuses([...statuses, status]);
    }
  };

  const toggleClosedType = (type) => {
    const next = closedTypes.includes(type)
      ? closedTypes.filter((c) => c !== type)
      : [...closedTypes, type];
    setClosedTypes(next);

    if (next.length === 0 && isClosedChecked) {
      setStatuses(statuses.filter((s) => s !== "closed"));
    } else if (next.length > 0 && !isClosedChecked) {
      setStatuses([...statuses, "closed"]);
    }
  };

  const closedIndeterminate =
    isClosedChecked &&
    closedTypes.length > 0 &&
    closedTypes.length < CLOSED_TYPES.length;

  const closedLabels = {
    founded: t("Conclusion.closed_founded"),
    unfounded: t("Conclusion.closed_unfounded"),
    undefined: t("Conclusion.closed_undetermined"),
    closing_process: t("status.closing_process"),
  };

  return (
    <Box className="status-filter">
      <p className="status-filter__label">
        {tExports("createFile.status_filter_label")}
      </p>
      <p className="status-filter__helper">
        {tExports("createFile.status_filter_helper")}
      </p>

      <Stack
        direction="row"
        flexWrap="wrap"
        rowGap={0.5}
        columnGap={2}
        className="status-filter__list"
      >
        {MAIN_STATUSES.map((status) => {
          const isChecked = statuses.includes(status);
          const isClosed = status === "closed";
          return (
            <EGCheckbox
              key={status}
              size="small"
              color="primary"
              checked={isChecked}
              indeterminate={isClosed ? closedIndeterminate : false}
              onChange={() => toggleStatus(status)}
              label={t(`status.${status}`)}
            />
          );
        })}
      </Stack>

      <Collapse in={isClosedChecked} timeout={200} unmountOnExit>
        <Box className="status-filter__sublist">
          <p className="status-filter__sublabel">
            {tExports("createFile.closed_subtypes_label")}
          </p>
          <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={2}>
            {CLOSED_TYPES.map((type) => (
              <EGCheckbox
                key={type}
                size="small"
                color="primary"
                checked={closedTypes.includes(type)}
                onChange={() => toggleClosedType(type)}
                label={closedLabels[type]}
              />
            ))}
          </Stack>
        </Box>
      </Collapse>
    </Box>
  );
};
